export default "__VITE_ASSET__xtZ9zJA9SM2UEmQzLKsBiw__"